import { call, put, all, takeEvery } from 'redux-saga/effects'
import {
  CREATE_BULK_GAM_LINE_ITEMS,
  CREATE_GAM_LINE_ITEM_FORECAST,
  createBulkGamLineItemsFailure,
  createBulkGamLineItemsSuccess,
  GET_GAM_AD_UNIT_SIZES,
  createGamLineItemForecastFailure,
  createGamLineItemForecastSuccess,
  GET_GOOGLE_AD_MANAGER_AD_UNIT,
  GET_GOOGLE_AD_MANAGER_AD_UNITS,
  GET_ONSITE_RATES,
  getGamAdUnitSizesFailure,
  getGamAdUnitSizesSuccess,
  getGoogleAdManagerAdUnitFailure,
  getGoogleAdManagerAdUnitsFailure,
  getGoogleAdManagerAdUnitsSuccess,
  getGoogleAdManagerAdUnitSuccess,
  getOnsiteRatesFailure,
  getOnsiteRatesSuccess
} from '../actions/googleAdManager'
import {
  createBulkGamLineItemsService,
  createGamLineItemForecastService,
  getGamAdUnitSizesService,
  getGoogleAdManagerAdUnitService,
  getGoogleAdManagerAdUnitsService,
  getOnsiteRatesService
} from '../services/googleAdManager'

function* googleAdManagerWatcher() {
  yield all([
    // PLOP_APPEND_PATTERN_ANCHOR_WATCHER
    takeEvery(CREATE_GAM_LINE_ITEM_FORECAST, createGamLineItemForecastWorker),
    takeEvery(GET_ONSITE_RATES, getOnsiteRatesWorker),
    takeEvery(GET_GOOGLE_AD_MANAGER_AD_UNIT, getGoogleAdManagerAdUnitWorker),
    takeEvery(GET_GOOGLE_AD_MANAGER_AD_UNITS, getGoogleAdManagerAdUnitsWorker),
    takeEvery(CREATE_BULK_GAM_LINE_ITEMS, createBulkGamLineItemsWorker),
    takeEvery(GET_GAM_AD_UNIT_SIZES, getGamAdUnitSizesWorker)
  ])
}

// PLOP_APPEND_PATTERN_ANCHOR_WORKER

function* getGoogleAdManagerAdUnitsWorker({ params }) {
  try {
    const response = yield call(getGoogleAdManagerAdUnitsService, params)
    yield put(getGoogleAdManagerAdUnitsSuccess(response))
  } catch (error) {
    yield put(getGoogleAdManagerAdUnitsFailure(error))
  }
}

function* getGoogleAdManagerAdUnitWorker({ params }) {
  try {
    const response = yield call(getGoogleAdManagerAdUnitService, params)
    yield put(getGoogleAdManagerAdUnitSuccess(response))
  } catch (error) {
    yield put(getGoogleAdManagerAdUnitFailure(error))
  }
}

function* getOnsiteRatesWorker({ params }) {
  try {
    const response = yield call(getOnsiteRatesService, params)
    yield put(getOnsiteRatesSuccess(response))
  } catch (error) {
    yield put(getOnsiteRatesFailure(error))
  }
}

function* createBulkGamLineItemsWorker({ data }) {
  try {
    const response = yield call(createBulkGamLineItemsService, data)
    yield put(createBulkGamLineItemsSuccess(response))
  } catch (error) {
    yield put(createBulkGamLineItemsFailure(error))
  }
}

function* createGamLineItemForecastWorker({ data }) {
  try {
    const response = yield call(createGamLineItemForecastService, data)
    yield put(createGamLineItemForecastSuccess(response))
  } catch (error) {
    yield put(createGamLineItemForecastFailure(error))
  }
}

function* getGamAdUnitSizesWorker({ params }) {
  try {
    const response = yield call(getGamAdUnitSizesService, params)
    yield put(getGamAdUnitSizesSuccess(response))
  } catch (error) {
    yield put(getGamAdUnitSizesFailure(error))
  }
}

export default googleAdManagerWatcher
